<template>
<div class="login">
  <div class="login_warp">
      <a-form @submit="handleSubmit" :form="form" style="margin:0 auto">
        <a-form-item>
          <a-input v-decorator="['userName',
          { initialValue: 'admin' ,rules: [{ required: true, message: 'Please input your username!' }] }]"
            placeholder="Username"
            style="width: 200px"
          >
            <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input v-decorator="['password',
          {  initialValue: 123456 ,rules: [{ required: true, message: 'Please input your password!' }] }]"
            type="password"
            placeholder="password"
            style="width: 200px"
          >
            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
          </a-input>
        </a-form-item>
            <a-form-item
          :wrapper-col="{ span: 12, offset: 5 }"
        >
          <a-button
            type="primary"
            html-type="submit"
          >
            Submit
          </a-button>
        </a-form-item>
      </a-form>
  </div>
</div>
</template>

<script>

export default {
  data(){
    return{
      
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if(values.userName=="admin" && values.password==123456){
            this.$message.success("登录成功")
            setTimeout(()=>{
              this.$router.push('/')
            },2000)
            localStorage.setItem("userinfo",values.userName)
          }else{
            this.$message.error("账号或密码错误")
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.login{
  position: relative;
  width:100%;
  height:100%;
  background-image: url(../../assets/img/5a0bae486145f.jpg);
  background-size: 100%;
}
.login_warp{
    position: absolute;
    left:50%;
    top:50%;
    width:350px;
    margin:-190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255,255,255, 0.3);
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/main/Login.vue